module.exports = __webpack_public_path__ + "static/media/youtube.c193940f.svg";